"use client";

import { CapabilityPage } from "@/components/sections/page-composer";
import { webhooksData } from "@/lib/data/developers-webhooks";

export function WebhooksPage() {
  return <CapabilityPage data={webhooksData} />;
}
